var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMinhaConta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.77,
    height: 39.77,
    viewBox: "0 0 39.77 39.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-icons",
    transform: "translate(1.125 1.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-minha-conta"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grid-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4695",
    "data-name": "Path 4695",
    d: "M5.179,3.375H17.445a1.8,1.8,0,0,1,1.8,1.8V17.445a1.8,1.8,0,0,1-1.8,1.8H5.179a1.8,1.8,0,0,1-1.8-1.8V5.179A1.8,1.8,0,0,1,5.179,3.375Z",
    transform: "translate(-3.375 -3.375)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    "data-name": "Path 4696",
    d: "M22.054,3.375H34.32a1.8,1.8,0,0,1,1.8,1.8V17.445a1.8,1.8,0,0,1-1.8,1.8H22.054a1.8,1.8,0,0,1-1.8-1.8V5.179A1.8,1.8,0,0,1,22.054,3.375Z",
    transform: "translate(1.396 -3.375)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4697",
    "data-name": "Path 4697",
    d: "M5.179,20.25H17.445a1.8,1.8,0,0,1,1.8,1.8V34.32a1.8,1.8,0,0,1-1.8,1.8H5.179a1.8,1.8,0,0,1-1.8-1.8V22.054A1.8,1.8,0,0,1,5.179,20.25Z",
    transform: "translate(-3.375 1.396)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4698",
    "data-name": "Path 4698",
    d: "M22.054,20.25H34.32a1.8,1.8,0,0,1,1.8,1.8V34.32a1.8,1.8,0,0,1-1.8,1.8H22.054a1.8,1.8,0,0,1-1.8-1.8V22.054A1.8,1.8,0,0,1,22.054,20.25Z",
    transform: "translate(1.396 1.396)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinhaConta);
export default __webpack_public_path__ + "static/media/ic_minha-conta.00850c7239c5121094eced15bebad7ed.svg";
export { ForwardRef as ReactComponent };